export default __webpack_public_path__ + "675404892c7614b2a99bbfbadfe83e9e.svg";